

<section class="container mt-5 centrar">
    <h1 class="error">
        {{mensajeError}}
    </h1>
    <button class="btn "routerLink="/eventos/evento/HDR926">
        Presiona aquí
    </button>
</section>

